import Tooltip from "@/overlay/components/CommonParts/Tooltip";
import styles from "@/overlay/components/Legends/MapLegends.module.scss";
import { t } from "@lingui/core/macro";
import type React from "react";

export type MapLegendControlsProps = {
  onHide: () => void;
  label: string;
};

export const MapLegendControls = ({ label, onHide }: MapLegendControlsProps) => {
  return (
    <div className={styles["controls-map-legend"]}>
      <div className={styles["parameter-text"]}>{label}</div>
      <Tooltip message={t`Hide legend`} direction="right">
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
        <span className="material-icons" onClick={onHide}>
          visibility_off
        </span>
      </Tooltip>
    </div>
  );
};
